import { useCallback, useEffect, useRef } from 'react';

const useInterval = (callback, delay) => {
  const savedCallback = useRef(null);
  const intervalRef = useRef(null);

  const clear = useCallback(() => {
    if (!intervalRef.current) {
      return;
    }

    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }, []);

  const resetInterval = useCallback(() => {
    clear();

    if (delay == null) {
      return;
    }
    intervalRef.current = setInterval(() => {
      savedCallback.current?.();
    }, delay);
  }, [delay, clear]);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    resetInterval();
    return () => {
      clear();
    };
  }, [resetInterval, clear]);

  return { resetInterval };
};

export default useInterval;
